var _g, _circle, _circle2, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoTryunfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 590,
    height: 416,
    viewBox: "0 0 590 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3_103)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 294.892,
    cy: 208,
    r: 151,
    fill: "#036B52"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    filter: "url(#filter1_if_3_103)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 294.892,
    cy: 208,
    r: 135.536,
    fill: "#036B52"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.892,
    cy: 208,
    r: 141.938,
    stroke: "#2FC18C",
    strokeWidth: 12.8044
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_3_103)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 294.892,
    cy: 208,
    r: 123.711,
    fill: "url(#paint0_radial_3_103)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3_103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5868 222.642C70.7401 214.31 77.4268 207.838 85.7921 206.958L515.995 161.697C525.684 160.678 533.758 169.021 532.422 178.671L520.568 264.314C519.415 272.646 512.728 279.117 504.363 279.997L74.1599 325.258C64.4709 326.278 56.3963 317.934 57.7321 308.284L69.5868 222.642Z",
    fill: "url(#paint1_linear_3_103)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.6744 225.24L532.186 180.059L521.426 260.746L57.7846 307.874L69.6744 225.24Z",
    fill: "url(#paint2_linear_3_103)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter4_f_3_103)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.32 239.517L107.998 242.076L116.402 233.456L109.451 299.462L92.6384 301.231L99.5893 235.225L106.345 242.25L82.0699 244.804L83.4676 231.764L133.671 226.483L132.32 239.517Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.643 296.812L142.143 225.591L171.566 222.496C178.273 221.79 183.234 222.653 186.45 225.084C189.663 227.484 191.502 230.887 191.965 235.295C192.237 237.877 192.08 240.472 191.495 243.08C190.91 245.689 189.973 248.127 188.683 250.395C187.391 252.633 185.777 254.537 183.841 256.11C181.937 257.679 179.783 258.685 177.378 259.129C179.025 259.052 180.575 259.255 182.026 259.739C183.475 260.191 184.676 261.02 185.63 262.225C186.582 263.398 187.168 265.039 187.39 267.149C187.496 268.156 187.496 269.366 187.39 270.778C187.315 272.186 187.173 273.713 186.964 275.359C186.787 277.001 186.594 278.645 186.385 280.29C186.176 281.936 186.02 283.48 185.918 284.924C185.846 286.364 185.864 287.587 185.97 288.595C186.032 289.193 186.122 289.741 186.238 290.238C186.382 290.7 186.548 291.065 186.735 291.332L169.875 293.105C169.528 292.537 169.291 291.639 169.161 290.411C169.062 289.466 169.058 288.369 169.149 287.117C169.237 285.835 169.352 284.502 169.492 283.118C169.662 281.7 169.832 280.297 170.005 278.91C170.177 277.523 170.312 276.235 170.41 275.047C170.505 273.828 170.505 272.777 170.413 271.895C170.224 270.101 169.468 268.811 168.144 268.028C166.848 267.209 165.035 266.922 162.705 267.167L146.364 268.886L154.483 263.448L151.125 295.078L134.643 296.812ZM154.846 259.638L147.715 255.852L164.622 254.073C166.574 253.868 168.338 253.236 169.914 252.179C171.518 251.087 172.741 249.701 173.583 248.021C174.453 246.306 174.777 244.394 174.555 242.284C174.34 240.238 173.579 238.599 172.271 237.367C170.961 236.105 168.999 235.611 166.385 235.886L149.667 237.644L158.076 229.072L154.846 259.638Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M253.139 213.914L227.864 262.795L225.189 287.286L208.423 289.05L211.004 264.569L195.568 219.97L212.995 218.137L223.095 255.131L216.389 255.837L234.862 215.836L253.139 213.914Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M309.953 253.108C309.016 262.056 306.037 268.991 301.016 273.912C295.994 278.834 289.548 281.708 281.677 282.537C274.152 283.328 268.191 282.348 263.795 279.595C259.396 276.811 256.866 272.286 256.207 266.021C255.982 263.88 255.946 261.719 256.098 259.538C256.247 257.326 256.516 254.432 256.904 250.858L261.047 213.081L277.907 211.308L273.513 251.689C273.324 253.524 273.17 255.084 273.05 256.37C272.963 257.652 272.907 258.788 272.884 259.778C272.889 260.732 272.944 261.713 273.05 262.721C273.308 265.176 274.115 266.938 275.468 268.005C276.854 269.069 278.916 269.457 281.655 269.169C285.244 268.791 287.921 267.459 289.686 265.172C291.483 262.882 292.6 259.581 293.038 255.27L297.885 209.206L314.745 207.432L309.953 253.108Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M334.639 275.771L318.203 277.5L325.704 206.279L353.143 203.392L364.004 267.142L362.893 267.928L369.862 201.633L386.25 199.909L378.749 271.13L351.121 274.037L340.237 210.528L341.585 209.718L334.639 275.771Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M405.003 210.829L413.439 202.062L410.395 231.224L405.666 227.567L434.285 224.556L432.893 237.643L404.273 240.654L409.945 235.569L406.503 268.21L389.69 269.979L397.191 198.758L441.632 194.082L440.282 207.117L405.003 210.829Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M471.409 262.575C466.34 263.108 461.646 262.52 457.328 260.81C453.038 259.064 449.492 256.222 446.69 252.283C443.885 248.313 442.159 243.258 441.513 237.118C440.871 231.01 441.217 225.227 442.553 219.771C443.886 214.282 446.091 209.371 449.168 205.036C452.242 200.67 456.086 197.114 460.7 194.368C465.341 191.588 470.638 189.885 476.588 189.259C481.752 188.715 486.461 189.302 490.717 191.019C495 192.701 498.541 195.496 501.34 199.404C504.135 203.28 505.856 208.288 506.502 214.427C507.138 220.473 506.775 226.257 505.415 231.78C504.082 237.268 501.866 242.228 498.767 246.661C495.665 251.062 491.81 254.667 487.203 257.475C482.593 260.252 477.328 261.952 471.409 262.575ZM471.524 249.145C475.145 248.764 478.182 247.522 480.634 245.417C483.087 243.313 485.022 240.674 486.439 237.501C487.852 234.296 488.794 230.838 489.263 227.128C489.729 223.386 489.771 219.705 489.39 216.084C489.009 212.464 488.204 209.652 486.975 207.648C485.742 205.613 484.212 204.23 482.384 203.499C480.584 202.734 478.598 202.465 476.426 202.694C472.805 203.075 469.765 204.286 467.306 206.327C464.843 208.337 462.9 210.897 461.477 214.007C460.053 217.118 459.121 220.511 458.68 224.186C458.239 227.861 458.214 231.557 458.605 235.272C459.188 240.813 460.669 244.605 463.048 246.647C465.456 248.653 468.281 249.486 471.524 249.145Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.868 235.879L112.546 238.438L120.951 229.818L114 295.824L97.1866 297.593L104.137 231.587L110.893 238.612L86.6181 241.166L88.0158 228.126L138.219 222.844L136.868 235.879Z",
    fill: "url(#paint3_linear_3_103)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139.191 293.174L146.692 221.953L176.114 218.857C182.821 218.152 187.782 219.014 190.998 221.445C194.211 223.845 196.05 227.249 196.513 231.657C196.785 234.239 196.628 236.834 196.043 239.442C195.458 242.05 194.521 244.488 193.232 246.757C191.939 248.994 190.325 250.899 188.389 252.471C186.485 254.04 184.331 255.047 181.926 255.491C183.574 255.413 185.123 255.616 186.575 256.1C188.023 256.553 189.224 257.381 190.179 258.586C191.13 259.759 191.716 261.401 191.938 263.51C192.044 264.518 192.044 265.727 191.938 267.139C191.863 268.548 191.722 270.075 191.513 271.72C191.335 273.362 191.142 275.006 190.933 276.652C190.724 278.297 190.569 279.842 190.466 281.285C190.394 282.725 190.412 283.949 190.518 284.956C190.581 285.554 190.67 286.102 190.786 286.599C190.93 287.062 191.096 287.426 191.283 287.693L174.423 289.467C174.077 288.898 173.839 288 173.71 286.772C173.61 285.828 173.606 284.73 173.697 283.479C173.785 282.196 173.9 280.863 174.041 279.479C174.21 278.061 174.38 276.658 174.553 275.271C174.725 273.884 174.86 272.597 174.958 271.409C175.053 270.189 175.054 269.138 174.961 268.257C174.772 266.462 174.016 265.173 172.692 264.389C171.396 263.57 169.583 263.284 167.253 263.529L150.912 265.248L159.031 259.81L155.674 291.439L139.191 293.174ZM159.394 255.999L152.263 252.213L169.17 250.434C171.122 250.229 172.886 249.598 174.462 248.541C176.066 247.449 177.29 246.063 178.131 244.382C179.001 242.667 179.326 240.755 179.104 238.646C178.888 236.599 178.127 234.96 176.82 233.729C175.509 232.466 173.547 231.972 170.934 232.247L154.215 234.006L162.624 225.433L159.394 255.999Z",
    fill: "url(#paint4_linear_3_103)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M257.687 210.275L232.413 259.156L229.737 283.647L212.971 285.411L215.552 260.93L200.116 216.332L217.543 214.498L227.643 251.493L220.937 252.198L239.41 212.198L257.687 210.275Z",
    fill: "url(#paint5_linear_3_103)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M314.501 249.47C313.564 258.418 310.585 265.353 305.564 270.274C300.542 275.195 294.096 278.07 286.225 278.898C278.7 279.69 272.739 278.709 268.343 275.957C263.944 273.172 261.415 268.648 260.755 262.382C260.53 260.241 260.494 258.08 260.646 255.899C260.796 253.687 261.064 250.794 261.452 247.22L265.595 209.443L282.456 207.669L278.061 248.051C277.872 249.885 277.718 251.445 277.599 252.731C277.511 254.014 277.455 255.15 277.432 256.139C277.437 257.093 277.492 258.074 277.598 259.082C277.857 261.538 278.663 263.299 280.017 264.367C281.402 265.431 283.464 265.818 286.203 265.53C289.793 265.153 292.47 263.82 294.235 261.534C296.031 259.244 297.148 255.943 297.586 251.631L302.433 205.567L319.293 203.793L314.501 249.47Z",
    fill: "url(#paint6_linear_3_103)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M339.187 272.132L322.752 273.861L330.252 202.64L357.691 199.754L368.553 263.504L367.442 264.289L374.41 197.995L390.798 196.271L383.297 267.491L355.669 270.398L344.785 206.889L346.133 206.079L339.187 272.132Z",
    fill: "url(#paint7_linear_3_103)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M409.551 207.19L417.988 198.424L414.944 227.585L410.214 223.929L438.834 220.917L437.441 234.004L408.821 237.015L414.494 231.93L411.052 264.571L394.239 266.34L401.739 195.119L446.18 190.444L444.83 203.478L409.551 207.19Z",
    fill: "url(#paint8_linear_3_103)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M475.957 258.937C470.888 259.47 466.195 258.881 461.876 257.171C457.586 255.426 454.04 252.584 451.238 248.645C448.433 244.674 446.707 239.619 446.061 233.479C445.419 227.371 445.765 221.589 447.101 216.132C448.434 210.644 450.639 205.732 453.716 201.398C456.791 197.031 460.634 193.475 465.248 190.73C469.89 187.949 475.186 186.246 481.136 185.62C486.3 185.077 491.009 185.664 495.265 187.381C499.548 189.063 503.089 191.858 505.888 195.765C508.683 199.641 510.404 204.649 511.05 210.789C511.686 216.834 511.324 222.618 509.963 228.141C508.63 233.629 506.414 238.59 503.315 243.022C500.213 247.423 496.358 251.028 491.751 253.837C487.141 256.614 481.877 258.314 475.957 258.937ZM476.072 245.507C479.693 245.126 482.73 243.883 485.183 241.779C487.635 239.674 489.57 237.035 490.987 233.862C492.401 230.657 493.342 227.2 493.811 223.49C494.277 219.748 494.32 216.067 493.939 212.446C493.558 208.825 492.752 206.013 491.523 204.01C490.29 201.975 488.76 200.592 486.932 199.861C485.133 199.095 483.147 198.826 480.974 199.055C477.353 199.436 474.313 200.647 471.854 202.689C469.392 204.698 467.448 207.259 466.025 210.369C464.601 213.479 463.669 216.872 463.228 220.547C462.787 224.223 462.762 227.918 463.153 231.633C463.736 237.175 465.217 240.966 467.597 243.008C470.004 245.015 472.829 245.848 476.072 245.507Z",
    fill: "url(#paint9_linear_3_103)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M306.328 133.633L317.695 153.464C318.34 154.58 319.334 155.047 320.39 155.047C321.971 155.047 323.614 153.872 323.614 151.877L323.672 112.219C323.672 110.225 322.091 108.992 320.507 108.992C319.45 108.992 318.398 109.521 317.753 110.637L306.328 130.409C306.037 130.88 305.916 131.463 305.916 131.992C305.916 132.579 306.033 133.108 306.328 133.633Z",
    fill: "#2FC18C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M294.553 140.379L305.978 160.152C306.274 160.681 306.448 161.268 306.448 161.793C306.448 163.496 304.926 164.962 303.225 164.962C302.697 164.962 302.169 164.845 301.644 164.55L267.368 144.661C266.254 144.015 265.788 142.957 265.788 141.962C265.788 140.321 267.019 138.676 269.011 138.676L291.804 138.793C292.976 138.793 294.029 139.38 294.557 140.376",
    fill: "#2FC18C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M291.741 125.009H268.949C266.957 125.009 265.784 123.426 265.784 121.839C265.784 120.782 266.254 119.728 267.364 119.083L301.699 99.3139C302.227 99.0223 302.813 98.8434 303.342 98.8434C305.043 98.8434 306.507 100.309 306.507 102.071C306.507 102.6 306.332 103.128 306.037 103.653L294.495 123.426C293.909 124.425 292.914 125.009 291.741 125.009Z",
    fill: "#2FC18C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3_103",
    x: 143.892,
    y: 57,
    width: 302,
    height: 309.317,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.31678
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.65839
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.184314 0 0 0 0 0.756863 0 0 0 0 0.54902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3_103"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_if_3_103",
    x: 131.918,
    y: 45.0259,
    width: 325.948,
    height: 325.948,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.4628
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3_103"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.31678,
    result: "effect2_foregroundBlur_3_103"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_3_103",
    x: 87.0385,
    y: 0.146202,
    width: 415.708,
    height: 415.708,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.0715
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_103"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_103",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.4628
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3_103"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3_103",
    x: 0.881943,
    y: 114.053,
    width: 588.391,
    height: 277.141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.14597
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.3525
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_103"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_103",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3_103",
    x: 72.924,
    y: 179.917,
    width: 443.028,
    height: 130.46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.57299,
    result: "effect1_foregroundBlur_3_103"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3_103",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(306.718 276.678) rotate(-106.227) scale(190.424)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313437,
    stopColor: "#002D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934697,
    stopColor: "#036B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_103",
    x1: 336.05,
    y1: 255.173,
    x2: 339.434,
    y2: 297.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FC18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544413,
    stopColor: "#4BF8B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_103",
    x1: 327.679,
    y1: 195.514,
    x2: 338.59,
    y2: 282.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BF8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#2FC18C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_103",
    x1: 292.093,
    y1: 202.085,
    x2: 302.276,
    y2: 298.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493703,
    stopColor: "#001A13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_103",
    x1: 292.093,
    y1: 202.085,
    x2: 302.276,
    y2: 298.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493703,
    stopColor: "#001A13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_103",
    x1: 292.093,
    y1: 202.085,
    x2: 302.276,
    y2: 298.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493703,
    stopColor: "#001A13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_103",
    x1: 292.093,
    y1: 202.085,
    x2: 302.276,
    y2: 298.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493703,
    stopColor: "#001A13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3_103",
    x1: 292.093,
    y1: 202.085,
    x2: 302.276,
    y2: 298.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493703,
    stopColor: "#001A13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3_103",
    x1: 292.093,
    y1: 202.085,
    x2: 302.276,
    y2: 298.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493703,
    stopColor: "#001A13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3_103",
    x1: 292.093,
    y1: 202.085,
    x2: 302.276,
    y2: 298.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493703,
    stopColor: "#001A13"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTryunfo);
export default __webpack_public_path__ + "static/media/logo_tryunfo.a75bcf5174f90b4fb56dd82c85530910.svg";
export { ForwardRef as ReactComponent };